/* eslint-disable */

// On the exam training detail page

import $ from "jquery";

let self;

export class WC_Product_Exam {

  constructor() {
    self = this;
    $('.detail_wrapper').on('click', '.training_selector', function (e) {

      $('.training_selector').each(function () {
        $(this).removeClass('selected');
      })

      $(this).addClass('selected');

      $('.lyceo_training_id').val($(this).data('id'));

    });

  }

}
